import useSWR, { SWRResponse, SWRConfiguration } from 'swr';
import { AxiosError } from 'axios';
import { Signature, Offer } from '../../../providers/api/dtos';
import { API_OFFERS_PATH } from '../../../providers/api/api';
import { getOfferAcceptanceSignatureStatus } from '../../../providers/api/offer/offerProvider';

export const OFFER_ACCEPTANCE_SIGNATURE_STATUS_RID = `${API_OFFERS_PATH}/acceptance/signature-status`;

export default function useOfferAcceptanceSignatureStatus(
  offerId?: NonNullable<Offer['id']>,
  options?: SWRConfiguration<Signature, AxiosError>,
): SWRResponse<Signature, AxiosError> {
  const key = offerId ? [OFFER_ACCEPTANCE_SIGNATURE_STATUS_RID, offerId] : null;

  return useSWR(key, () => getOfferAcceptanceSignatureStatus(offerId!), options);
}
